import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import useTranslation from 'hooks/useTranslation';

const ModalAddWebsiteForm = ({
  values,
  errors,
  handleAddNewWebsite,
  handleChange,
  hasOperatorsByDefault,
  setHasOperatorsByDefault,
}) => {
  const handleHasOperatorsChange = (event) => {
    const { checked } = event.target;
    setHasOperatorsByDefault(checked);
  };
  const { getTranslation } = useTranslation("WEBSITES");
  const { t } = getTranslation();

  const renderWebsiteNameInput = (
    <div className='modal__container__body__addwebsite__address__inner'>
      <div className='form-control'>
        <input
          name='title'
          value={values.title}
          onChange={handleChange}
          className={clsx(errors.title && 'has-error')}
          type='text'
          placeholder={t("MODAL").ADD_WEBSITE_FORM_TITLE}
          id='siteTitle'
          required
          autoFocus
        />
        {errors.title && <div className='error'>{errors.title}</div>}
      </div>
      <div className='form-control'>
        <input
          type='text'
          name='websiteUrl'
          value={values.websiteUrl}
          onChange={handleChange}
          className={clsx(errors.websiteUrl && 'has-error')}
          placeholder={t("MODAL").ADD_WEBSITE_FORM_ADDRESS}
          required
        />
        {errors.websiteUrl && <div className='error'>{errors.websiteUrl}</div>}
      </div>
    </div>
  );

  const renderHasOperatorsCheckbox = (
    <div className='form-control'>
      <input
        type='checkbox'
        id='addAgents'
        checked={hasOperatorsByDefault}
        onChange={handleHasOperatorsChange}
      />
      <label htmlFor='addAgents' aria-describedby='label'>
      {t("MODAL").ADD_WEBSITE_FORM_ADD_ALL}
      </label>
    </div>
  );

  return (
    <form onSubmit={handleAddNewWebsite}>
      <div className='modal__container__body__addwebsite__address flex flex-ai-s flex-wrap'>
        {renderWebsiteNameInput}
      </div>
      <div className='modal__container__body__addwebsite__addagents'>
        {renderHasOperatorsCheckbox}
      </div>
    </form>
  );
};

ModalAddWebsiteForm.propTypes = {
  handleAddNewWebsite: PropTypes.func.isRequired,
  values: PropTypes.object,
  errors: PropTypes.object,
  hasOperatorsByDefault: PropTypes.bool.isRequired,
  setHasOperatorsByDefault: PropTypes.func.isRequired,
};

export default ModalAddWebsiteForm;
